import React, { useEffect, useState } from 'react';
import { Carousel } from 'antd';
import { Link } from 'react-router-dom';

interface SlideItem {
  id: string;
  title: string;
  description: string;
  imageUrl: string;
}

const Slider: React.FC = () => {
  const [slides, setSlides] = useState<SlideItem[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchSlides = async () => {
      try {
        setLoading(true);
        // Giả lập API call
       // await new Promise(resolve => setTimeout(resolve, 1000));

        // Mock data
        const mockSlides: SlideItem[] = [
          {
            id: '1',
            title: 'Nơi lưu giữ hồn văn hóa Cơ Tu',
            description: 'Âm nhạc và múa chính là linh hồn của di sản văn hóa Cơ Tu.',
            imageUrl: '/slide/slide1.jpg',
          },
          {
            id: '2',
            title: 'Những điệu dân vũ mang nét riêng',
            description: 'Cuộc sống gần gũi với thiên nhiên, núi rừng, lối sống phóng khoáng đã hun đúc cho người Cơ Tu những điệu dân vũ mang nét riêng.',
            imageUrl: '/slide/slide2.jpg',
          },
          {
            id: '3',
            title: 'Huyện Nam Trà My',
            description: 'Huyện Nam Trà My phát triển sau 20 năm tái lập.',
            imageUrl: '/slide/slide3.jpg',
          },
        ];

        setSlides(mockSlides);
      } catch (error) {
        console.error('Error fetching slides:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchSlides();
  }, []);

  if (loading || slides.length === 0) {
    return null; // hoặc hiển thị skeleton loading
  }

  return (
    <Carousel arrows infinite={true}
      className="qti-slide"
      autoplay
      dotPosition="bottom"
      effect="fade"
      autoplaySpeed={3000}
    >
      {slides.map((slide) => (
        <Link key={slide.id} to={''}>
          <div className="slide-content">
            <img
              className="slide-image"
              src={slide.imageUrl}
              alt={slide.title}
            />
            <div className="slide-overlay">
              <h3 className="slide-title">{slide.title}</h3>
              <p className="slide-description">{slide.description}</p>
            </div>
          </div>
        </Link>
      ))}
    </Carousel>
  );
};

export default Slider;


// import React, { useEffect, useState } from 'react';
// import { Carousel } from 'antd';
// import { Link } from 'react-router-dom';
// import { apiCaller } from 'src/util/apiCaller'; // Import apiCaller để gọi API

// interface SlideItem {
//   id: number;
//   title: string;
//   description: string;
//   imageUrl: string;
//   link: string;
// }

// const Slider: React.FC = () => {
//   const [slides, setSlides] = useState<SlideItem[]>([]);
//   const [loading, setLoading] = useState(true);

//   useEffect(() => {
//     const fetchSlides = async () => {
//       try {
//         setLoading(true);
//         const response = await apiCaller({ url: '/apipublic/tulieuhienthis?istulieu=true', method: 'GET' });
        
//         const mockSlides: SlideItem[] = response.data.content.map((item: any) => ({
//           id: item.id,
//           title: item.tenTuLieu,
//           description: item.moTa,
//           imageUrl: item.anhDaiDien, // Giả sử đây là URL ảnh
//           link: `/public/tu-lieu/lich-su/${item.id}` // Điều chỉnh link theo yêu cầu
//         }));

//         setSlides(mockSlides);
//       } catch (error) {
//         console.error('Error fetching slides:', error);
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchSlides();
//   }, []);

//   if (loading || slides.length === 0) {
//     return null; // Hoặc hiển thị skeleton loading
//   }

//   return (
//     <Carousel
//       className="styled-carousel"
//       autoplay
//       dotPosition="bottom"
//       effect="fade"
//       autoplaySpeed={3000}
//     >
//       {slides.map((slide) => (
//         <Link to={slide.link} key={slide.id}>
//           <div className="slide-content">
//             <img
//               className="slide-image"
//               src={slide.imageUrl}
//               alt={slide.title}
//             />
//             <div className="slide-overlay">
//               <h3 className="slide-title">{slide.title}</h3>
//               <p className="slide-description">{slide.description}</p>
//             </div>
//           </div>
//         </Link>
//       ))}
//     </Carousel>
//   );
// };

// export default Slider;